<template>
    <div>
        <app-erros-box :erros="erros2" v-if="erros2.length > 0"></app-erros-box>
        <app-tabela
            :itens="requisicaoComprometimentos"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
            <template slot="valor" slot-scope="data">{{
                data.valor | currency
            }}</template>
            <template slot="acoes" slot-scope="data">
                <btn-visualizar-rateio-requisicao
                    :requisicao="requisicao"
                    :comprometimento="data"
                    :dataServicos="dataServicos"
                ></btn-visualizar-rateio-requisicao>
            </template>
        </app-tabela>
    </div>
</template>

<script>
import BtnVisualizarRateioRequisicao from './BtnVisualizarRateioRequisicao'

export default {
    components: {
        BtnVisualizarRateioRequisicao
    },

    props: {
        requisicao: {
            type: Object,
            default: () => {}
        },

        dataServicos: {
            type: Object
        }
    },

    data() {
        return {
            requisicaoComprometimentos: [],
            comprometimentosSelecionados: [],
            erros: [],
            erros2: [],
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'idComprometimento',
                    label: 'Id',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'dataEmissao',
                    label: 'Data de Emissão',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center',
                    type: 'date'
                },
                {
                    key: 'dataMovimento',
                    label: 'Data do Movimento',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center',
                    type: 'date'
                },
                {
                    key: 'historico',
                    label: 'Histórico',
                    filterable: true
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'idRm',
                    label: 'ID RM',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'situacao',
                    label: 'Situação',
                    type: 'status'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'qtdAnexos',
                    label: 'Qtd. Anexos'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime',
                    tdClass: 'text-nowrap text-center'
                }
            ],
            itensPorPagina: 10
        }
    },

    mounted() {
        this.requisicaoComprometimentos = [...this.requisicao.comprometimentos]
    },

    watch: {
        requisicao() {
            this.requisicaoComprometimentos = [
                ...this.requisicao.comprometimentos
            ]
        }
    }
}
</script>
